"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  border-bottom: none;
  border-left: 1px solid ${config_1.colors.sidewalk};
  height: 70px;
  width: 100%;
  margin-top: 8px;
  margin-right: 40px;

  @media ${config_1.device.tablet} {
    border-bottom: 1px solid ${config_1.colors.sidewalk};
    width: 265px;
  }
`;
